/**
 * CompletionStep Component
 *
 * Final step of the onboarding wizard.
 * Celebration moment with quick action cards to get started.
 */

import { useNavigate } from "react-router-dom";
import { PartyPopper, Upload, Calendar, ArrowRight } from "lucide-react";
import { Button } from "../../ui/button";
import { useCurrentUser } from "../../../hooks/useCurrentUser";

export function CompletionStep() {
  const navigate = useNavigate();
  const { data: user } = useCurrentUser();
  const displayName = user?.first_name || "there";

  const handleGoToDashboard = () => {
    // Check for pending checkout plan
    const pendingPlanId = localStorage.getItem("pendingCheckoutPlanId");
    if (pendingPlanId) {
      localStorage.removeItem("pendingCheckoutPlanId");
      navigate(
        `/account?tab=billing&auto_checkout=${encodeURIComponent(pendingPlanId)}`,
        { replace: true }
      );
      return;
    }
    navigate("/dashboard", { replace: true });
  };

  return (
    <div className="text-center space-y-8 py-4">
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
        <PartyPopper className="w-8 h-8 text-primary" />
      </div>

      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-foreground">
          You're all set, {displayName}!
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Your account is ready. Here's what you can do next:
        </p>
      </div>

      <div className="grid gap-3 max-w-sm mx-auto">
        <button
          onClick={() => navigate("/reflections")}
          className="flex items-center gap-3 p-4 rounded-lg border border-border bg-card hover:bg-muted/50 transition-colors text-left"
        >
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Upload className="w-5 h-5 text-primary" />
          </div>
          <div>
            <div className="text-sm font-medium text-foreground">
              Upload your first conversation
            </div>
            <div className="text-xs text-muted-foreground">
              Get AI-powered insights instantly
            </div>
          </div>
          <ArrowRight className="w-4 h-4 text-muted-foreground ml-auto" />
        </button>

        <button
          onClick={() => navigate("/tracker")}
          className="flex items-center gap-3 p-4 rounded-lg border border-border bg-card hover:bg-muted/50 transition-colors text-left"
        >
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Calendar className="w-5 h-5 text-primary" />
          </div>
          <div>
            <div className="text-sm font-medium text-foreground">
              Try the relationship tracker
            </div>
            <div className="text-xs text-muted-foreground">
              Log daily entries and track patterns
            </div>
          </div>
          <ArrowRight className="w-4 h-4 text-muted-foreground ml-auto" />
        </button>
      </div>

      <Button size="lg" onClick={handleGoToDashboard} className="gap-2">
        Go to Dashboard
        <ArrowRight className="w-4 h-4" />
      </Button>
    </div>
  );
}
